import React from 'react'

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    clipRule="evenodd"
    viewBox="0 0 350 346"
  >
      <path
        fill="#E5F2FF"
        fillRule="nonzero"
        d="M56-64.7c32 24.8 84 27.8 96.9 45.9 12.9 18.1-13.3 51.2-35.1 84.7-21.9 33.5-39.4 67.4-72 94.1-32.6 26.7-80.2 46.1-110.4 29.8-30.2-16.3-43-68.3-68.7-112.8-25.7-44.6-64.4-81.6-59.2-110.9 5.1-29.4 54.2-51 93.5-74.5 39.4-23.6 69.2-49.1 90.1-38.5C12-136.3 24-89.6 56-64.7z"
        transform="translate(-107.025 -150.629) translate(300 300)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M379.466 336.376H245.89c-5.521 0-10.354-2.953-13.007-7.366a15.085 15.085 0 007.799 2.159h137.525c.382 1.749.802 3.487 1.259 5.207zM491.715 160.77v-5.652h5.207v2.13a21.453 21.453 0 00-.845 2.996c-1.458.12-2.914.295-4.362.526z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M496.077 160.244c.211-1.027.494-2.028.845-2.996v2.933a60 60 0 00-.845.063z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M496.922 155.118h-5.207v-8.449a31.43 31.43 0 015.207-5.737v14.186zm-4.343-23.903l-.864-.864v-7.437c0-2.854-.787-5.523-2.155-7.8 4.41 2.649 7.362 7.478 7.362 13.008v.278a41.811 41.811 0 00-4.343 2.815z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M491.715 146.669v-16.318l.864.864a41.811 41.811 0 014.343-2.815v12.532a31.43 31.43 0 00-5.207 5.737z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M484.255 109.848a15.094 15.094 0 00-3.944-1.629 2.709 2.709 0 013.944 1.629z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M491.715 122.914v193.09c0 8.372-6.793 15.165-15.164 15.165H240.682c-8.371 0-15.164-6.793-15.164-15.165v-193.09c0-8.387 6.793-15.164 15.164-15.164h235.869c8.371 0 15.164 6.777 15.164 15.164z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#00176A"
        fillRule="nonzero"
        d="M491.715 122.914v26.996H225.518v-26.996c0-8.387 6.793-15.164 15.164-15.164h235.869c8.371 0 15.164 6.777 15.164 15.164z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AEE2F9"
        fillRule="nonzero"
        d="M264.087 192.198H238.4a2.324 2.324 0 01-2.325-2.324v-25.688a2.324 2.324 0 012.325-2.324h25.687a2.324 2.324 0 012.325 2.324v25.688a2.324 2.324 0 01-2.325 2.324zM307.308 192.198H281.62a2.324 2.324 0 01-2.324-2.324v-25.688a2.324 2.324 0 012.324-2.324h25.688a2.324 2.324 0 012.325 2.324v25.688a2.324 2.324 0 01-2.325 2.324zM350.529 192.198h-25.688a2.323 2.323 0 01-2.324-2.324v-25.688a2.323 2.323 0 012.324-2.324h25.688a2.324 2.324 0 012.325 2.324v25.688a2.324 2.324 0 01-2.325 2.324zM393.75 192.198h-25.688a2.323 2.323 0 01-2.324-2.324v-25.688a2.323 2.323 0 012.324-2.324h25.688a2.323 2.323 0 012.324 2.324v25.688a2.323 2.323 0 01-2.324 2.324zM436.971 192.849v-1.302h-25.688a1.676 1.676 0 01-1.674-1.673v-25.688a1.676 1.676 0 011.674-1.673h25.688a1.675 1.675 0 011.673 1.673v25.688a1.675 1.675 0 01-1.673 1.673v1.302a2.975 2.975 0 002.975-2.975v-25.688a2.974 2.974 0 00-2.975-2.975h-25.688a2.975 2.975 0 00-2.976 2.975v25.688a2.976 2.976 0 002.976 2.975h25.688zM480.191 192.198h-25.687a2.324 2.324 0 01-2.325-2.324v-25.688a2.324 2.324 0 012.325-2.324h25.687a2.324 2.324 0 012.325 2.324v25.688a2.324 2.324 0 01-2.325 2.324zM264.087 232.903H238.4a2.325 2.325 0 01-2.325-2.325V204.89a2.324 2.324 0 012.325-2.324h25.687a2.324 2.324 0 012.325 2.324v25.688a2.325 2.325 0 01-2.325 2.325zM307.308 232.903H281.62a2.325 2.325 0 01-2.324-2.325V204.89a2.324 2.324 0 012.324-2.324h25.688a2.324 2.324 0 012.325 2.324v25.688a2.325 2.325 0 01-2.325 2.325zM350.529 233.554v-1.302h-25.688a1.676 1.676 0 01-1.673-1.674V204.89a1.674 1.674 0 011.673-1.673h25.688a1.676 1.676 0 011.674 1.673v25.688a1.677 1.677 0 01-1.674 1.674v1.302a2.975 2.975 0 002.975-2.976V204.89a2.974 2.974 0 00-2.975-2.975h-25.688a2.975 2.975 0 00-2.975 2.975v25.688a2.976 2.976 0 002.975 2.976h25.688zM393.75 232.903h-25.688a2.324 2.324 0 01-2.324-2.325V204.89a2.323 2.323 0 012.324-2.324h25.688a2.323 2.323 0 012.324 2.324v25.688a2.324 2.324 0 01-2.324 2.325zM436.971 232.903h-25.688a2.325 2.325 0 01-2.325-2.325V204.89a2.324 2.324 0 012.325-2.324h25.688a2.323 2.323 0 012.324 2.324v25.688a2.324 2.324 0 01-2.324 2.325zM480.191 232.903h-25.687a2.325 2.325 0 01-2.325-2.325V204.89a2.324 2.324 0 012.325-2.324h25.687a2.324 2.324 0 012.325 2.324v25.688a2.325 2.325 0 01-2.325 2.325zM264.087 273.607H238.4a2.325 2.325 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.687a2.325 2.325 0 012.325 2.325v25.688a2.325 2.325 0 01-2.325 2.324zM307.308 273.607H281.62a2.325 2.325 0 01-2.324-2.324v-25.688a2.325 2.325 0 012.324-2.325h25.688a2.325 2.325 0 012.325 2.325v25.688a2.325 2.325 0 01-2.325 2.324zM350.529 273.607h-25.688a2.324 2.324 0 01-2.324-2.324v-25.688a2.324 2.324 0 012.324-2.325h25.688a2.325 2.325 0 012.325 2.325v25.688a2.325 2.325 0 01-2.325 2.324zM393.75 273.607h-25.688a2.325 2.325 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.688a2.324 2.324 0 012.324 2.325v25.688a2.324 2.324 0 01-2.324 2.324zM436.971 273.607h-25.688a2.325 2.325 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.688a2.324 2.324 0 012.324 2.325v25.688a2.324 2.324 0 01-2.324 2.324zM480.191 273.607h-25.687a2.325 2.325 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.687a2.325 2.325 0 012.325 2.325v25.688a2.325 2.325 0 01-2.325 2.324zM264.087 314.962v-1.302H238.4a1.676 1.676 0 01-1.674-1.673v-25.688a1.677 1.677 0 011.674-1.674h25.687c.924.002 1.672.75 1.674 1.674v25.688a1.676 1.676 0 01-1.674 1.673v1.302a2.976 2.976 0 002.976-2.975v-25.688a2.975 2.975 0 00-2.976-2.975H238.4a2.975 2.975 0 00-2.976 2.975v25.688a2.976 2.976 0 002.976 2.975h25.687zM307.308 314.311H281.62a2.324 2.324 0 01-2.324-2.324v-25.688a2.325 2.325 0 012.324-2.325h25.688a2.325 2.325 0 012.325 2.325v25.688a2.324 2.324 0 01-2.325 2.324zM350.529 314.311h-25.688a2.323 2.323 0 01-2.324-2.324v-25.688a2.324 2.324 0 012.324-2.325h25.688a2.325 2.325 0 012.325 2.325v25.688a2.324 2.324 0 01-2.325 2.324zM393.75 314.311h-25.688a2.324 2.324 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.688a2.324 2.324 0 012.324 2.325v25.688a2.323 2.323 0 01-2.324 2.324zM436.971 314.311h-25.688a2.324 2.324 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.688a2.324 2.324 0 012.324 2.325v25.688a2.323 2.323 0 01-2.324 2.324zM480.191 314.311h-25.687a2.324 2.324 0 01-2.325-2.324v-25.688a2.325 2.325 0 012.325-2.325h25.687a2.325 2.325 0 012.325 2.325v25.688a2.324 2.324 0 01-2.325 2.324z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#BFE7FA"
        fillRule="nonzero"
        d="M247.063 131.266a5.517 5.517 0 11-11.034 0 5.517 5.517 0 0111.034 0zM294.041 131.266a5.517 5.517 0 11-11.034 0 5.517 5.517 0 0111.034 0zM341.02 131.266a5.517 5.517 0 11-11.034 0 5.517 5.517 0 0111.034 0zM387.998 131.266a5.517 5.517 0 11-11.033 0 5.517 5.517 0 0111.033 0zM434.977 131.266a5.517 5.517 0 11-11.034 0 5.517 5.517 0 0111.034 0zM481.956 131.266a5.517 5.517 0 11-11.034 0 5.517 5.517 0 0111.034 0z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#272A66"
        fillRule="nonzero"
        d="M244.253 131.266v-25.899a2.707 2.707 0 00-5.414 0v25.899a2.707 2.707 0 005.414 0zM291.231 131.266v-25.899a2.707 2.707 0 00-5.414 0v25.899a2.707 2.707 0 005.414 0zM338.21 131.266v-25.899a2.707 2.707 0 00-5.414 0v25.899a2.707 2.707 0 005.414 0zM432.167 131.266v-25.899a2.707 2.707 0 00-5.414 0v25.899a2.707 2.707 0 005.414 0zM479.146 131.266v-25.899a2.707 2.707 0 00-5.414 0v25.899a2.707 2.707 0 005.414 0z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M337.121 270.35c.19.011.369.011.559.011.19 0 .369 0 .559-.011"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#E7505C"
        fillRule="nonzero"
        d="M414.79 180.633l7.315 6.116a1.951 1.951 0 002.838-.357l10.54-14.649a1.952 1.952 0 10-3.17-2.281l-9.314 12.944-5.704-4.769a1.952 1.952 0 10-2.505 2.996z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M433.454 202.566h-7.403l12.332-7.625 2.234 3.614a119.484 119.484 0 00-7.163 4.011z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#89BBD8"
        fillRule="nonzero"
        d="M424.077 208.865l-2.272-3.674 4.246-2.625h7.403a120.619 120.619 0 00-9.377 6.299z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M426.051 202.566h-2.143a24.428 24.428 0 0114.475-7.625l-12.332 7.625z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#89BBD8"
        fillRule="nonzero"
        d="M421.805 205.191a24.467 24.467 0 012.103-2.625h2.143l-4.246 2.625z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M579.551 205.723a22.494 22.494 0 01-1.131-1.436l1.46.904-.329.532z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M574.159 214.446a120.455 120.455 0 00-15.781-11.538l4.925-7.967 15.117 9.346c.356.493.734.971 1.131 1.436l-5.392 8.723z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M579.88 205.191l-1.46-.904a20.524 20.524 0 01-1.717-2.817 24.353 24.353 0 013.177 3.721z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M578.42 204.287l-15.117-9.346a24.426 24.426 0 0113.4 6.529c.498.99 1.072 1.926 1.717 2.817zM516.091 186.985a120.77 120.77 0 00-19.169-1.727v-1.161h10.948a21.512 21.512 0 008.221 2.108v.78z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M516.091 186.205a21.512 21.512 0 01-8.221-2.108h8.221v2.108z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#85A5C0"
        fillRule="nonzero"
        d="M493.878 185.264c-.337-.381-.666-.77-.984-1.167h4.028v1.161a110.19 110.19 0 00-3.044.006z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#1C4078"
        fillRule="nonzero"
        d="M491.715 185.314v-1.217h1.179c.318.397.647.786.984 1.167-.722.01-1.444.027-2.163.05z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M485.594 185.664v-1.567h6.121v1.217c-2.054.066-4.094.183-6.121.35z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M507.87 184.097h-1.695v-.914c.55.329 1.115.634 1.695.914zm-2.778 0h-2.231v-3.351a21.646 21.646 0 002.231 1.745v1.606zm-3.314 0h-2.231v-7.077a21.785 21.785 0 002.231 2.69v4.387zm-3.314 0h-1.542v-12.118a21.525 21.525 0 001.542 3.334v8.784z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M521.599 184.097h-2.168v-20.212h-1.083v20.212h-2.231v-20.212h-1.083v20.212h-2.232v-20.212h-1.082v20.212h-2.231v-20.212h-1.083v20.212h-.536c-.58-.28-1.145-.585-1.695-.914v-19.298h-1.083v18.606a21.646 21.646 0 01-2.231-1.745v-16.861h-1.083v15.825a21.785 21.785 0 01-2.231-2.69v-13.135h-1.083v11.428a21.525 21.525 0 01-1.542-3.334v-8.097h24.677v20.215z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#85A5C0"
        fillRule="nonzero"
        d="M496.922 184.097h-.689v-14.414c.188.784.419 1.549.689 2.296v12.118zm-1.772 0h-2.231v-20.212h-1.083v18.819a17.815 17.815 0 01-.121-.17v-18.652h3.932v.003h-.497v20.212z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#1C4078"
        fillRule="nonzero"
        d="M491.836 184.097h-.121v-1.563l.121.17v1.393zM496.922 171.979a21.496 21.496 0 01-.689-2.296v-5.798h-.586v-.003h1.275v8.097z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M491.715 184.097h-2.11v-20.212h-1.083v20.212h-2.231v-20.212h-1.083v20.212h-2.231v-20.212h-.48l-.001-.003h9.219v20.215z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#89BBD8"
        fillRule="nonzero"
        d="M481.894 184.097h-1.808v-20.215h2.41l.001.003h-.603v20.212z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M482.977 184.097h-.461v-19.911c0-.102-.007-.202-.019-.301h.48v20.212z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#89BBD8"
        fillRule="nonzero"
        d="M482.516 184.097h-.622v-20.212h.603c.012.099.019.199.019.301v19.911z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M486.291 184.097h-1.083v-20.212h1.083v20.212z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M488.522 163.885H489.605V184.09699999999998H488.522z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#85A5C0"
        fillRule="nonzero"
        d="M492.919 184.097h-.025a31.874 31.874 0 01-1.058-1.393v-18.819h1.083v20.212z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#1C4078"
        fillRule="nonzero"
        d="M492.894 184.097h-1.058v-1.393c.34.474.693.939 1.058 1.393z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#85A5C0"
        fillRule="nonzero"
        d="M496.233 184.097h-1.083v-20.212h.497a21.662 21.662 0 00.586 5.798v14.414z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#1C4078"
        fillRule="nonzero"
        d="M496.233 169.683a21.662 21.662 0 01-.586-5.798h.586v5.798z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M499.547 184.097h-1.083v-8.784c.335.587.696 1.157 1.083 1.707v7.077z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M499.547 177.02c-.387-.55-.748-1.12-1.083-1.707v-11.428h1.083v13.135z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M502.861 184.097h-1.083v-4.387c.349.358.71.703 1.083 1.036v3.351z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M502.861 180.746a21.611 21.611 0 01-1.083-1.036v-15.825h1.083v16.861z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M506.175 184.097h-1.083v-1.606c.353.241.715.472 1.083.692v.914z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M506.175 183.183c-.368-.22-.73-.451-1.083-.692v-18.606h1.083v19.298z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M508.406 163.885H509.48900000000003V184.09699999999998H508.406z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M511.72 163.885H512.802V184.09699999999998H511.72z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M516.117 184.097h-1.083v-20.212h1.083v20.212z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M518.348 163.885H519.4309999999999V184.09699999999998H518.348z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#0F4C8C"
        fillRule="nonzero"
        d="M521.599 163.882h-24.677v-3.701a58.074 58.074 0 0124.677 3.701z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#85A5C0"
        fillRule="nonzero"
        d="M495.647 163.882h-3.932v-3.112a57.782 57.782 0 014.362-.526 21.776 21.776 0 00-.43 3.638z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#1C4078"
        fillRule="nonzero"
        d="M496.922 163.882h-1.275c.042-1.242.188-2.457.43-3.638a60 60 0 01.845-.063v3.701z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M491.715 163.882h-9.219a2.315 2.315 0 00-.247-.779 57.995 57.995 0 019.466-2.333v3.112z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#89BBD8"
        fillRule="nonzero"
        d="M482.496 163.882h-2.41a56.956 56.956 0 012.163-.779c.125.238.211.501.247.779z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#CBD4DE"
        fillRule="nonzero"
        d="M611.786 356.954c-1.768-2.583-3.151-5.162-4.189-7.726 5.312-13.569 8.227-28.337 8.227-43.789v-.076a203.11 203.11 0 014.571-7.16c.421 4.09.636 8.242.636 12.444 0 16.412-3.289 32.055-9.245 46.307z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#AAC8DD"
        fillRule="nonzero"
        d="M500.843 430.835c-25.795 0-49.695-8.128-69.274-21.96h1.739c.334 0 .663-.02.986-.058 17.957 10.678 38.933 16.81 61.341 16.81 50.926 0 94.456-31.676 111.962-76.399 1.038 2.564 2.421 5.143 4.189 7.726-18.132 43.39-60.977 73.881-110.943 73.881zm114.981-125.472c-.019-31.836-12.416-60.773-32.639-82.266 20.463 19.252 34.175 45.596 37.21 75.106a203.11 203.11 0 00-4.571 7.16z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#C4D2DF"
        fillRule="nonzero"
        d="M433.308 408.875h-1.739a120.892 120.892 0 01-18.277-15.886 120.66 120.66 0 0021.002 15.828 8.436 8.436 0 01-.986.058z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FFC52F"
        fillRule="nonzero"
        d="M424.19 212.263l-7.592-12.28 16.577-10.249 7.592 12.28-16.577 10.249z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FFC52F"
        fillRule="nonzero"
        d="M416.598 199.983a24.422 24.422 0 0116.577-10.249l-16.577 10.249zM567.081 212.263l7.592-12.28-16.578-10.249-7.591 12.28 16.577 10.249z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FFC52F"
        fillRule="nonzero"
        d="M574.673 199.983a24.422 24.422 0 00-16.578-10.249l16.578 10.249z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FF9C2F"
        fillRule="nonzero"
        d="M480.386 178.89H510.88500000000005V188.85999999999999H480.386z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FFC52F"
        fillRule="nonzero"
        d="M516.392 158.674v20.216h-41.513v-20.216a58.113 58.113 0 0141.513 0z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#161846"
        fillRule="nonzero"
        d="M477.77 178.89v-20.212h-1.083v20.212M481.084 178.89v-20.212h-1.083v20.212M484.397 178.89v-20.212h-1.082v20.212M487.711 178.89v-20.212h-1.082v20.212M491.025 178.89v-20.212h-1.082v20.212M494.339 178.89v-20.212h-1.082v20.212M497.653 178.89v-20.212h-1.082v20.212M500.967 178.89v-20.212h-1.083v20.212M504.281 178.89v-20.212h-1.083v20.212M507.595 178.89v-20.212h-1.083v20.212M510.909 178.89v-20.212h-1.083v20.212M514.223 178.89v-20.212h-1.083v20.212"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FFC52F"
        fillRule="nonzero"
        d="M516.392 158.674h-41.513a58.113 58.113 0 0141.513 0zM615.824 305.439c0 66.378-53.81 120.188-120.189 120.188-66.378 0-120.188-53.81-120.188-120.188s53.81-120.188 120.188-120.188c66.379 0 120.189 53.81 120.189 120.188z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#BEB6CA"
        d="M495.635 413.717c-59.8 0-108.277-48.478-108.277-108.278 0-59.8 48.477-108.277 108.277-108.277 59.8 0 108.278 48.477 108.278 108.277 0 59.8-48.478 108.278-108.278 108.278zm0-212.766c-57.707 0-104.488 46.781-104.488 104.488s46.781 104.488 104.488 104.488 104.488-46.781 104.488-104.488-46.781-104.488-104.488-104.488z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#fff"
        fillRule="nonzero"
        d="M600.123 305.439c0 57.707-46.781 104.488-104.488 104.488s-104.488-46.781-104.488-104.488 46.781-104.488 104.488-104.488 104.488 46.781 104.488 104.488z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#272A66"
        fillRule="nonzero"
        d="M593.627 302.732H583.34a2.707 2.707 0 000 5.414h10.287a2.707 2.707 0 000-5.414zM498.342 403.431v-10.287a2.707 2.707 0 00-5.414 0v10.287a2.707 2.707 0 005.414 0zM397.644 308.146h10.286a2.707 2.707 0 000-5.414h-10.286a2.707 2.707 0 000 5.414zM492.928 207.448v10.286a2.707 2.707 0 005.414 0v-10.286a2.707 2.707 0 00-5.414 0z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#B7B9C7"
        fillRule="nonzero"
        d="M580.495 356.063c-.276 0-.555-.07-.811-.218l-8.908-5.144a1.624 1.624 0 011.624-2.813l8.909 5.144a1.624 1.624 0 01-.814 3.031zM446.635 391.925a1.625 1.625 0 01-1.405-2.437l5.143-8.908a1.624 1.624 0 112.813 1.624l-5.143 8.908a1.625 1.625 0 01-1.408.813zM419.681 263.208c-.276 0-.555-.07-.811-.218l-8.908-5.143a1.624 1.624 0 111.624-2.813l8.909 5.143a1.625 1.625 0 01-.814 3.031zM539.489 231.111a1.624 1.624 0 01-1.405-2.437l5.144-8.908a1.624 1.624 0 112.813 1.624l-5.143 8.908a1.625 1.625 0 01-1.409.813zM544.617 391.936a1.622 1.622 0 01-1.408-.813l-5.142-8.909a1.625 1.625 0 012.814-1.624l5.141 8.909a1.625 1.625 0 01-1.405 2.437zM410.765 356.044a1.624 1.624 0 01-.813-3.032l8.909-5.141a1.624 1.624 0 111.623 2.813l-8.909 5.142a1.624 1.624 0 01-.81.218zM451.798 231.101a1.625 1.625 0 01-1.408-.813l-5.141-8.909a1.624 1.624 0 112.813-1.624l5.142 8.91a1.624 1.624 0 01-1.406 2.436zM571.6 263.225a1.624 1.624 0 01-.814-3.031l8.91-5.141a1.624 1.624 0 111.623 2.813l-8.909 5.141a1.614 1.614 0 01-.81.218z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#FFC52F"
        fillRule="nonzero"
        d="M521.133 343.668a3.244 3.244 0 01-2.628-1.335l-26.519-36.386 26.098-70.703a3.248 3.248 0 116.095 2.25l-24.893 67.438 24.471 33.575a3.247 3.247 0 01-2.624 5.161z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
      <path
        fill="#272A66"
        fillRule="nonzero"
        d="M503.756 305.439a8.121 8.121 0 11-16.242 0 8.121 8.121 0 0116.242 0zM385.189 131.266v-25.899a2.707 2.707 0 00-5.414 0v25.899a2.707 2.707 0 005.414 0z"
        transform="translate(-107.025 -150.629) translate(300 300) matrix(.71948 0 0 .71948 -296.8 -162.068)"
      ></path>
  </svg>
);
